"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHoneycomb = exports.HONEYCOMB_SIZES = void 0;
const tiles_1 = require("./tiles");
exports.HONEYCOMB_SIZES = [
    tiles_1.TILE_SIZES.HONEYCOMB_10X11,
    tiles_1.TILE_SIZES.HONEYCOMB_11X10
];
function isHoneycomb(tileSize) {
    return exports.HONEYCOMB_SIZES.includes(tileSize);
}
exports.isHoneycomb = isHoneycomb;
//# sourceMappingURL=honeycomb.js.map